/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import Download from '@/utils/Download'

const MAX_CHARS_TO_DISPLAY: number = 50 * 1024
const TRUNCATED_WARNING: string = '\n---------------------------------------------------------------------\n' +
                                  'Warning: Log was truncated, use the "Download" button to get the whole file'

@Component({
    mixins: [AnalysisServiceMixin],
})
export default class AnalysisLogs extends Vue {
    private analysisService: AnalysisService
    private logs = ''

    public async mounted() {
        if (this.$route.params.analysisId !== undefined) {
            await this.loadAnalysisLogs(Number(this.$route.params.analysisId))
        }
    }

    public async downloadAnalysisLogs(): Promise<void> {
        try {
            const data = await this.analysisService.downloadAnalysisLogs(Number(this.$route.params.analysisId))
            Download.makeDownloadLink(data, `syslogs.txt`)
        } catch (e) {
            const errorMessage = `Failed to download syslog: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }

    private async loadAnalysisLogs(analysisId: number): Promise<void> {
        try {
            const wholeLogs = await this.analysisService.getAnalysisLogs(analysisId)
            if (wholeLogs.length > MAX_CHARS_TO_DISPLAY) {
                this.logs = wholeLogs.substring(0, MAX_CHARS_TO_DISPLAY)
                this.logs += TRUNCATED_WARNING
            } else {
                this.logs = wholeLogs
            }
        } catch (e) {
            const errorMessage = `Failed to load syslog: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }
}
